export default {
  loading: false,
  navigation: {},
  userProfile: {},
  msalAccount: null,
  isInvoiceOnly: null,
  isCUK: null,
  isM2M: null
};
